import React, { useState, useEffect } from 'react';
import { login, getStores } from '../api';

function Login({ onLogin, systemName = '居家健康管理系统' }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [storeId, setStoreId] = useState('');
  const [stores, setStores] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 即使API失败，也要确保下拉框始终显示
  useEffect(() => {
    getStores().then(res => {
      if (res.data && res.data.data) {
        setStores(res.data.data);
      }
    }).catch(() => {
      // API失败时保持空数组，但下拉框仍显示
      setStores([]);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('请输入用户名和密码');
      return;
    }

    // 必须选择门店
    if (!storeId) {
      setError('请选择门店后再登录');
      return;
    }

    try {
      setLoading(true);
      setError('');

      const res = await login(username, password, storeId);
      if (res.data.success) {
        const user = res.data.data;

        // 检测账号和门店是否匹配
        if (storeId === 'admin') {
          // 管理后台只能admin账号登录
          if (user.role !== 'admin') {
            setError('只有管理员才能登录管理后台');
            setLoading(false);
            return;
          }
        } else {
          // 门店用户必须选择对应门店，且必须有该门店权限
          if (!user.store_id) {
            setError('您的账号未绑定门店，请联系管理员');
            setLoading(false);
            return;
          }
          if (parseInt(storeId) !== user.store_id) {
            setError('您没有该门店的权限，请选择正确的门店');
            setLoading(false);
            return;
          }
        }

        onLogin(res.data.data, storeId);
      } else {
        setError(res.data.message || '登录失败');
      }
    } catch (err) {
      setError('登录失败，请检查网络');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-title">{systemName}</div>
        <div className="login-subtitle">请登录您的账户</div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>用户名</label>
            <input
              type="text"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="请输入用户名"
            />
          </div>

          <div className="form-group">
            <label>密码</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="请输入密码"
            />
          </div>

          {/* 门店下拉框 - 登录成功后不再显示，用户只能用自己有权限的门店登录 */}
          <div className="form-group">
            <label>门店</label>
            <select
              className="form-input"
              value={storeId}
              onChange={(e) => setStoreId(e.target.value)}
            >
              <option value="">请选择门店</option>
              <option value="admin">管理后台</option>
              {stores.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>
          </div>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? '登录中...' : '登录'}
          </button>
        </form>
      </div>

      <style>{`
        .login-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: #f0f2f5;
        }
        .login-box {
          width: 360px;
          padding: 40px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        .login-title {
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 8px;
        }
        .login-subtitle {
          font-size: 14px;
          color: #999;
          text-align: center;
          margin-bottom: 32px;
        }
        .login-box .form-group {
          margin-bottom: 20px;
        }
        .login-box .form-group label {
          display: block;
          margin-bottom: 8px;
          color: #666;
        }
        .login-box .form-input {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          font-size: 14px;
        }
        .login-box .form-input:focus {
          outline: none;
          border-color: #1890ff;
        }
        .login-error {
          color: #f5222d;
          font-size: 14px;
          margin-bottom: 16px;
        }
        .login-btn {
          width: 100%;
          padding: 10px;
          background: #1890ff;
          color: #fff;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          cursor: pointer;
        }
        .login-btn:hover {
          background: #40a9ff;
        }
        .login-btn:disabled {
          background: #d9d9d9;
        }
        .login-tip {
          text-align: center;
          margin-top: 20px;
          font-size: 12px;
          color: #999;
        }
      `}</style>
    </div>
  );
}

export default Login;